<div class="container">
    <div class="row">
        <h3 class="ff-medium fw-semibold fs-6 py-3">Mi Yamaha</h3>
        <p class="ff-light">Bienvenido, aquí tu puedes tener acceso a todos tus vehículos toyota o agregar nuevos vehículos</p>
    </div>
    <div class="row mb-4">
        <div class="col-12 col-md-6 col-lg-6">
            <div class="text-center">
               <a routerLink="login" class="d-block w-50 m-auto text-uppercase ff-medium py-2 px-4 rounded-2 my-4 link w-50" (click)="cerrarMenu()">Iniciar sesión</a>   
            </div>
        </div>
        <div class="col-12 col-md-6 col-lg-6">
            <div class="text-center">
                <a routerLink="usuario/registro" class="d-block w-50 m-auto text-uppercase ff-medium py-2 px-4 rounded-2 my-4 link" (click)="cerrarMenu()">Crear cuenta</a>
            </div>
        </div>
    </div>
</div>
